import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgUtilities = (props) => (
  <SvgIcon {...props} title="Utilities">
    <svg
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#Utilities_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.633.3C1.27.76-.79 4.02.27 7.204a5.292 5.292 0 0 0 2.537 2.962l.194.1v6.014c0 6.726-.013 6.196.163 6.62.84 2.018 3.857 1.736 4.294-.402.073-.358.055-2.147-.023-2.306a.773.773 0 0 0-1.22-.204c-.203.203-.201.191-.214 1.252l-.012.938-.077.156a.726.726 0 0 1-1.323 0l-.077-.156-.011-6.329-.012-6.328-.055-.106c-.112-.213-.231-.306-.554-.434C1.859 8.184.93 5.795 1.894 3.872c.72-1.435 2.303-2.272 3.873-2.046a.922.922 0 0 1 .193.04c.018.016-.917.92-1.423 1.378-.582.526-.783.934-.802 1.624-.057 2.058 2.365 2.957 3.77 1.4.435-.482 1.39-1.469 1.405-1.452.008.01.026.096.04.193.243 1.686-.727 3.34-2.327 3.972-.338.134-.457.23-.562.46l-.06.132.006 2.962.006 2.962.055.11c.274.558 1.093.558 1.368 0l.054-.11.012-2.618.011-2.618.188-.098a5.218 5.218 0 0 0 2.249-6.96c-.254-.507-.671-.691-1.093-.484-.143.07-1.736 1.69-2.477 2.517-.328.368-.664.409-.956.116-.293-.292-.252-.626.116-.955.825-.739 2.447-2.335 2.518-2.478.093-.19.094-.498.002-.673C7.744.645 5.88.13 4.633.3ZM15.259 10.82c-.599.13-.458.017-4.218 3.399-3.577 3.217-3.423 3.073-3.492 3.255a.75.75 0 0 0 .762 1.03c.262-.016.303-.046 1.277-.922l.902-.812.012 2.833c.012 2.826.012 2.833.063 3.013.233.821.896 1.448 1.706 1.616.327.067 6.634.067 6.962 0 .81-.168 1.472-.795 1.705-1.616.052-.18.052-.187.064-3.013l.011-2.833.903.812c.973.876 1.015.906 1.276.923a.75.75 0 0 0 .762-1.031c-.064-.17-.087-.193-.808-.84l-.633-.568-.011-2.006-.012-2.007-.054-.11c-.274-.556-1.095-.556-1.368 0l-.055.11-.011 1.321-.012 1.322-1.922-1.73c-2.169-1.952-2.204-1.98-2.722-2.122-.265-.073-.809-.085-1.087-.024Zm.798 1.545c.097.047.547.437 1.787 1.551l1.657 1.489-.006 3.386-.005 3.387-.061.13a.722.722 0 0 1-.368.38l-.156.076h-6.307l-.155-.077a.722.722 0 0 1-.369-.379l-.06-.13-.006-3.387-.005-3.386 1.641-1.477c2-1.8 1.968-1.778 2.413-1.563Z"
          fill="#017163"
        />
      </g>
      <defs>
        <clipPath id="Utilities_svg__a">
          <path fill="#fff" transform="translate(0 .274)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgUtilities;
